import type { BoardTeam, ManualResolutionContent } from '@nerds-at-play/contracts';
import { SafeMarkdown } from '../../components/SafeMarkdown.js';
import { WorldSituation } from './WorldSituation.js';

export function ConsequencePreview({
  content,
  teams,
  approved,
  published,
  round,
}: {
  content: ManualResolutionContent;
  teams: BoardTeam[];
  approved: boolean;
  published: boolean;
  round: number | null;
}) {
  return (
    <section aria-label="Round consequences" className="live-broadcast">
      <h3>
        Round {round} · {approved ? 'Approved consequences' : 'Saved consequence draft'}
      </h3>
      <p>
        {published
          ? 'Published. Public text is on the board; private updates went only to their teams.'
          : approved
            ? 'Approved · not published. Review below, then publish to deliver the public broadcast and each team’s private update together.'
            : 'Saved privately · not approved or published. Review / edit consequences to continue.'}
      </p>
      <h4>GM ONLY · assessment</h4>
      <SafeMarkdown content={content.summary} />
      <h4>PUBLIC · World Broadcast{!published && ' preview'}</h4>
      <strong>{content.broadcast.headline}</strong>
      <SafeMarkdown content={content.broadcast.publicMarkdown} />
      <details>
        <summary>PUBLIC · resulting world</summary>
        <WorldSituation world={content.nextState.publicWorld} />
      </details>
      {Object.entries(content.nextState.teams).map(([teamId, state]) => (
        <details key={teamId}>
          <summary>
            PRIVATE · {teams.find((t) => t.teamId === teamId)?.name ?? teamId} · consequences
          </summary>
          {content.privateBulletins
            .filter((b) => b.teamId === teamId)
            .map((b, i) => (
              <SafeMarkdown key={i} content={b.markdown} />
            ))}
          <h4>Resulting resources</h4>
          <ul>
            {Object.entries(state.resources).map(([name, value]) => (
              <li key={name}>
                {name}: {value}
              </li>
            ))}
          </ul>
          <h4>Capabilities</h4>
          <ul>
            {state.capabilities.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <h4>Liabilities</h4>
          <ul>
            {state.liabilities.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </details>
      ))}
    </section>
  );
}
